import { createFileRoute } from '@tanstack/react-router';
import { MarketingShell } from '@/components/marketing/MarketingShell';
import { RoadmapPage } from '@/components/marketing/RoadmapPage';

export const Route = createFileRoute('/_public/roadmap')({
  component: () => (
    <MarketingShell currentPath="/roadmap">
      <RoadmapPage />
    </MarketingShell>
  ),
});
